import { fetchCart, fetchUser } from "../utils/fetchLocalStorageData";
const userInfo = fetchUser();
const cartInfo = fetchCart();

export const initialState = {
    user: userInfo,
    products: null,
    cartShow: false,
    cartItems: cartInfo,
    pedido: 'burger',
    editShow: false,
    users: null,
    selecteddetail: null,
    headerShow: false,
    detalleShow: false,
    editar: null,
    userLogged: null,
    count: 120,
};